module.exports = __webpack_public_path__ + "img/button_obnovenie.05e3a141.svg";